export default {
  updates: {
    investorRelations: 'علاقات المستثمرين',
  },
  meetings: {
    investorRelations: 'علاقات المستثمرين',
    meetings: 'الاجتماعات',
    myMeetings: 'اجتماعاتي',
    newMeeting: 'اجتماع جديد',
    name: 'الاسم',
    date: 'التاريخ',
    type: 'النوع',
    status: 'الحالة',
    actions: 'خيارات',
    meetingName: 'اسم الاجتماع',
    meetingType: 'نوع الاجتماع',
    meetingDate: 'تاريخ الاجتماع',
    meetingTime: 'وقت الاجتماع',
    location: 'الموقع',
    conferenceLink: 'رابط المؤتمر',
    addAttendee: 'إضافة مشارك',
    back: 'رجوع',
    save: 'حفظ',
    addNewType: 'إضافة نوع جديد',
    enterName: 'أدخل الاسم',
    enterDays: 'أدخل الأيام',
    addMeetingDate: 'إضافة تاريخ الاجتماع',
    addMeetingTime: 'إضافة وقت الاجتماع',
    locationPlaceholder: 'أدخل الموقع',
    conferenceLinkPlaceholder: 'أدخل رابط المؤتمر',
    noticeDays: 'أيام الإشعار',
    edit: 'تعديل',
    delete: 'حذف',
    editMeeting: 'تعديل الاجتماع',
    deleteWarning: 'أنت على وشك حذف شيء مهم',
    deleteConfirmation: 'هل أنت متأكد من الحذف',
    yesDelete: 'نعم، احذف',
    meetingDetails: 'تفاصيل الاجتماع',
    editInfo: 'تعديل المعلومات',
    cancelMeeting: 'إلغاء الاجتماع',
    meetingAttendees: 'مشاركو الاجتماع',
    attendeeName: 'اسم المشارك',
    seenNotice: 'رؤية الإشعار',
    ownership: 'الملكية',
    action: 'الإجراء',
    attended: 'حضر',
    notAttended: 'لم يحضر',
    yes: 'نعم',
    no: 'لا',
    dateAndTime: 'التاريخ والوقت',
    discussedPoints: 'النقاط التي تم مناقشتها',
    theNextPhase: 'المرحلة التالية',
    havingContractWithFacebook: 'وجود عقد مع فيسبوك',
    meetingMinutes: 'محضر الاجتماع',
    meetingMinutesDescription:
      'هذه هي الوثيقة النهائية التي سيتلقاها الحاضرون. اكتب محضر الاجتماع وأي تفاصيل أخرى قد ترغب في إضافتها.',
    summary: 'ملخص',
    vote: 'تصويت',
    blank: 'فارغ',
    attendeesInclusion: 'شمول المشاركين',
    all: 'الكل',
    include: 'تضمين',
    exclude: 'استبعاد',
    ownershipInclusion: 'المساهمون الذين تتجاوز نسبة ملكيتهم X%',
    minimumOwnership: 'الحد الأدنى للملكية (%)',
    minimumOwnershipRequired: 'يرجى إدخال الحد الأدنى للملكية',
    minimumOwnershipInvalid: 'يرجى إدخال نسبة مئوية بين 0 و100',
    minimumOwnershipHelp: 'ستتم دعوة المساهمين النشطين الذين تتجاوز نسبة ملكيتهم هذه النسبة فقط.',
    announcement: 'إعلان',
    announcementNotification:
      'هذه هي الإشعار الذي سيتلقاه الحاضرون. سيتم إضافة جميع نقاط المناقشة أو التصويت التي أضفتها أعلاه تلقائيًا إلى هذه الوثيقة.',
    votingPoints: 'نقاط التصويت',
    votingPointsSubTitle: 'قم بإدراج جميع النقاط التي سيتم التصويت عليها خلال الاجتماع.',
    addNewPoint: 'إضافة نقطة جديدة',
    remove: 'إزالة',
    votingPointDescriptionPlaceholder: 'أدخل وصف نقطة التصويت',
    votingPointClausePlaceholder: 'أدخل بند نقطة التصويت',
    submit: 'إرسال',
    preview: 'معاينة',
    saveAndSend: 'حفظ وإرسال',
    deleteDraft: 'حذف المسودة',
    finishMeeting: 'إنهاء الاجتماع',
    sendDraft: 'إرسال المسودة',
    totalShares: 'إجمالي الأسهم',
    selectExcludedUsers: 'تحديد المستخدمين المستبعدين',
    add: 'إضافة',
    update: 'تحديث',
    sendDelegate: 'إرسال تفويض',
    attendance: 'الحضور',
    delegateVoteToUser: 'تفويض التصويت للمستخدم',
    selectDelegate: 'تحديد المفوض',
    results: 'النتائج',
    resultsByShareholder: 'النتائج حسب المساهم',
    clause: 'البند',
    pointDescription: 'وصف النقطة',
    myVote: 'تصويتي',
    meetingLink: 'رابط الاجتماع',
    link: 'الرابط',
    saveAnnouncementDraft: 'حفظ الاعلان',
    saveMinutesDraft: 'حفظ مسودة المحضر',
    saveMinutesOfMeeting: 'حفظ محضر الاجتماع',
    meetingGuests: 'ضيوف الاجتماع',
    validConferenceLinkError: 'يرجى إدخال رابط ويب صالح (مثال: https://example.com)',
    guests: 'الضيوف',
    meetingGuestsTooltip: 'سيتلقى الضيوف بريدًا إلكترونيًا يُعلمهم بالاجتماع ولكنهم لن يشاركوا في الاجتماع.',
    attachments: 'المرفقات',
    votingStartDate: 'تاريخ بدء التصويت',
    addVotingStartDate: 'إضافة تاريخ بدء التصويت',
    votingStartTime: 'وقت بدء التصويت',
    addVotingStartTime: 'إضافة وقت بدء التصويت',
    attendanceReport: 'تقرير الحضور',
    generatingAttendanceReport: 'جاري إنشاء تقرير الحضور',
    retryAttendanceReport: 'إعادة إنشاء تقرير الحضور',
    attendanceReportFailed: 'فشل إنشاء تقرير الحضور.',
    attendanceReportUnavailable: 'انتهت صلاحية تقرير الحضور أو أنه غير متاح. أعد إنشاءه.',
    value: 'القيمة',
    totalSharesPresentAttendees: 'إجمالي أسهم الحاضرين',
    totalOwnershipPresentAttendees: 'إجمالي ملكية الحاضرين',
    shareholders: 'الشركاء',
  },
};
